'use client';

import type { AnalyticsBrowser } from '@segment/analytics-next';
import { createContext } from 'react';

export const AnalyticsContext = createContext<{
  analytics: AnalyticsBrowser | null;
}>({
  analytics: null,
});
